// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3sYOp","sendOtp":"AuthorizeToLogin_sendOtp__1Kvvd"};